<template>
  <div v-if="announcement" class="py-10">
    <div class="bg-primary-200 rounded-lg border-bottom">
      <div class="flex items-center flex-wrap p-5">
        <div class="w-full md:w-4/12">
          <h3 class="text-primary-500 font-bold mb-0">
            Announcements
          </h3>
        </div>
        <div class="w-8/12 md:text-right pr-10">
          <a class="text-secondary-500 underline" href="/announcements">
            View All
          </a>
        </div>
      </div>
      <div class="px-5">
        <div class=" h-1 bg-primary-500 px-10 " />
      </div>

      <div class="px-10 py-5">
        <h3>{{ announcement.title }}</h3>
        <p>{{ announcement.startShowingDate | formatShortDate }}</p>
        <div class="wysiwyg-editor-container" v-html="announcement.html" />
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'AnnouncementComponent',
    parent: true,
    components: {

    },

    data: () => ({
      announcement: null,
      readMore: false,
    }),

    mounted() {
      this.getAnnouncements();
    },

    methods: {
      async getAnnouncements() {
        const { data } = await axios.get('/api/gateway/announcements?numToGet=1');
        this.announcement = data[0];
      },
    },
  };
</script>